module.exports = __webpack_public_path__ + "img/LTS_PIC.efbb8335.gif";